module.exports = __webpack_public_path__ + "img/underMaintenance.8de8f992.svg";